module.exports = __webpack_public_path__ + "img/coat-y.e67ba44f.png";